var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-radio-group',{staticStyle:{"font-size":"12px"},attrs:{"id":"time-radio-button","button-style":"solid","size":"small","value":_vm.value},on:{"change":e => _vm.$emit('input', e.target.value)}},_vm._l((_vm.options),function(item){return _c('a-radio-button',{key:item.value,attrs:{"value":item.value}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }